import React from "react";

const getTimeAgo = (date: string) => {
  const now = new Date();
  const pastDate = new Date(date);
  const diffTime = Math.abs(now.getTime() - pastDate.getTime());
  const diffDays = Math.round(diffTime / (1000 * 60 * 60 * 24));

  if (diffDays === 0) return "Today";
  if (diffDays === 1) return "1 day ago";
  if (diffDays < 7) return `${diffDays} days ago`;
  if (diffDays >= 7 && diffDays < 14) return "1 week ago";
  if (diffDays < 60) return `${Math.floor(diffDays / 7)} weeks ago`;



  return pastDate.toLocaleDateString();
};

export const formatDateTime = (iso: string) => {
  if (!iso || iso === 'null' || iso === 'undefined') {
    return null;
  }
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) {
    return null;
  }
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  return `${year}-${month}-${day}, ${hours}:${minutes}`;
};

export const TimeAgo = ({ date }: { date: string }) => {
  return <span>{getTimeAgo(date)} </span>;
}
